import { Pipe } from '@angular/core';

@Pipe({
    name: 'shorten'
})
export class ShortenStringPipe {
    transform(value, maxWidth = 30, suffix = '...') {
        if (value && value.length > maxWidth) {
            value = value.substring(0, maxWidth) + suffix;
        }
        return value;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/shorten.pipe.ts